<div class="main">
    <p-confirmPopup key="DT"></p-confirmPopup>
    <p-toast />
    <p-table #dt1 [value]="data" [dataKey]="key" [rows]="rows[0]" [showCurrentPageReport]="true"
        [rowsPerPageOptions]="rows" [loading]="loading" [paginator]="footer" [globalFilterFields]="filtrosGlobal"
        [scrollable]="true" [scrollHeight]="scrollHeight" [resizableColumns]="true" [metaKeySelection]="true"
        [columns]="selectedColumns" currentPageReportTemplate="{first} de {totalRecords}" selectionMode="multiple"
        editMode="row" styleClass="p-datatable-sm p-datatable-gridlines" rowGroupMode="subheader"
        groupRowsBy="representative" columnResizeMode="expand" (onRowSelect)="onRowSelect($event)"
        (onFilter)="onTableFilter($event)" showGridlines>

        <!-- =========================================================================================================================== -->
        <!-- ********************************************************* CAPTION ********************************************************* -->
        <!-- =========================================================================================================================== -->
        <button icon="pi pi-plus"> </button>
        <ng-template pTemplate="caption" *ngIf="caption">
            <div class="flex componentes-header">
                <div *ngIf="filterGlobal">
                    <!-- <span class="p-input-icon-left ml-auto">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt1.filterGlobal($event.target['value'], 'contains')"
                            placeholder="Buscar" class="p-inputtext-sm" />
                    </span> -->
                    <p-iconfield>
                        <p-inputicon styleClass="pi pi-search" />
                        <input type="text" pInputText type="text"
                            (input)="dt1.filterGlobal($event.target['value'], 'contains')" placeholder="Buscar"
                            (input)="imprimirGlobal(dt1,$event.target['value'])" pSize="small" />
                    </p-iconfield>
                </div>


                <!-- <button pButton class="p-button-outlined" icon="pi pi-filter-slash" (click)="clear(dt1)"
                    *ngIf="filter"></button> -->
                <div class="title-table">
                    {{title}}
                </div>
                <button pButton type="button" icon="pi pi-plus" (click)="addEmptyRowPre()" class="add-button"
                    *ngIf="addRow" [disabled]="disableAddRow"
                    [ngStyle]="colorBtnMas ? { 'background-color': 'var(--color-btn-verde)', 'border-color': 'var(--color-btn-verde)' } : {}">
                </button>
                <div style="width: 20px; height: 20px;" class="inputNFilas" *ngIf="numFilasAdd">
                    <p-inputNumber mode="decimal" [useGrouping]="false" inputStyleClass="inputNFilas" [min]="0"
                        placeholder="Ingrese Num Filas" [(ngModel)]="numfilaseditables"><!-- -->
                    </p-inputNumber>
                </div>



                <span *ngIf="customButtons.length !== 0"
                    style="width: 1px; background-color: #555555;height: 25px;"></span>
                <div style="display: flex; gap: 10px; align-items: center; justify-content: center;">
                    <ng-container *ngFor="let button of customButtons">
                        <button pButton [icon]="button.icon" [pTooltip]="button.toolTip" (click)="button.function()"
                            class="custom-button" [label]="button.text" [loading]="button.loading"
                            [disabled]="button?.disabled || btnDisabled || false">
                        </button>
                    </ng-container>
                    <button pButton label="R" (click)="resetSort()" pTooltip="Reestablecer filtros"
                        *ngIf="btnResetFiltros == true"></button>
                    <p-button *ngIf="exportDataCsv" icon="pi pi-file-excel"
                        styleClass="p-button-success p-button-outlined" (onClick)="export()"></p-button>
                </div>

                <span *ngIf="addLegend" style="width: 1px; background-color: #555555;height: 20px;"></span>
                <ng-container *ngTemplateOutlet="addLegend"></ng-container>

                <span style="width: 1px; background-color: #555555;height: 25px;" *ngIf="id"></span>
                <!-- <p-multiSelect [options]="cols" [(ngModel)]="selectedColumns" optionLabel="header"
                    selectedItemsLabel="{0} columnas seleccionadas"
                    [style]="{'min-width': '200px','width':'300px','height':'30px'}" placeholder="Choose Columns"
                    appendTo="body" class="p-multiSelect-sm" *ngIf="id"></p-multiSelect>
                <button pButton icon="pi pi-save" class="custom-button" (click)="saveOptionColumn()"
                    *ngIf="id"></button> -->
                <button pButton icon="pi pi-cog" class="custom-button" (click)="showOptionColumns()"
                    *ngIf="id"></button>

                <!-- LEYENDA -->

                <!-- LEYENDA COLOR HEXAGESIMAL -->
                <div class="leyendas-container flex align-items-center ml-auto">
                    <ng-container *ngFor="let leyenda of customLeyendasHex">
                        <div class="leyenda-item flex align-items-center ml-4">
                            <div class="leyenda-color-circle mr-1" [style.background]="leyenda.color"></div>
                            <span class="text-500" style="font-size: 10px;">{{ leyenda.texto }}</span>
                        </div>
                    </ng-container>
                </div>

                <!-- FIN LEYENDA -->
            </div>
            @if(showFilters && cadenaFiltrosConsolidada() != '' && cadenaFiltrosConsolidada() != null){
            <div class="filter-summary-container p-mt-2">
                <div class="filter-summary-content">
                    <span class="filter-title">
                        <i class="pi pi-filter"></i>
                    </span>

                    <span class="filter-text" [innerHTML]="cadenaFiltrosConsolidada()">
                    </span>
                </div>
            </div>
            }
        </ng-template>

        <!-- =========================================================================================================================== -->
        <!-- ********************************************************* HEADER ********************************************************** -->
        <!-- =========================================================================================================================== -->

        <ng-template pTemplate="header">
            <ng-container *ngTemplateOutlet="addHeaderTop"></ng-container>
            <tr class="header-table">
                <ng-container *ngTemplateOutlet="addHeaderStart"></ng-container>
                <!-- Columna para el selector de filas -->
                <th *ngIf="modeSelected" style="width: 40px; text-align:center;">
                    Seleccionar
                </th>
                <th *ngIf="metadataTableTree.length != 0"></th>
                <th *ngIf="rowDelete"></th>
                <ng-container *ngIf="btnEditAdelante">
                    <ng-container *ngTemplateOutlet="headerEdicion"></ng-container>
                </ng-container>
                @for (item of metadata; track item.field) {
                @if (item.verColumna?.(null) !== false) {
                <th pResizableColumn class="header bg-blue-100" pFrozenColumn [frozen]="item.frozen">
                    <div class="flex align-items-center items-header" [ngStyle]="styleHeader">
                        <span [innerHTML]="item.title"
                            style="text-align: center;margin: 5px 0px 5px 5px;font-size: 1.4vh;"></span>
                        <!--{{item.title}}-->
                        <p-button icon="pi pi-save" class="add-button" *ngIf="item.inputType == 'checkList'"
                            [disabled]="checkList.length === 0" (click)="item.function(this.checkList)"></p-button>

                        <p-button icon="pi pi-save" class="add-button" *ngIf="item.inputType == 'checkList2'"
                            size="small" [disabled]="!checkLists?.[item.field] ||checkLists?.[item.field]?.length === 0"
                            (onClick)="item?.function?.(checkLists?.[item.field])"></p-button>

                        <p-sortIcon [pSortableColumn]="item.field" [field]="item.field"
                            *ngIf="showSort && (item.inputType != 'checkList' && item.inputType != 'checkList2')"></p-sortIcon>
                        <p-columnFilter type="{{item['type']}}" field="{{item.field}}" display="menu"
                            styleClass="filtro-columnFilter"
                            *ngIf="filter && item.inputType != 'checkList' && item.inputType != 'checkList2'"
                            appendTo="body"></p-columnFilter>
                    </div>
                </th>
                }
                }
                <!-- @if(btnEditAdelante == false){
                <th *ngIf="(rowEdit) && !addRow"
                    style="display: flex; justify-content: center; align-items: center; height: 33px;">
                </th>
                <th *ngIf="addRow" style="display: flex; justify-content: center; align-items: center;">
                    <p-button (click)="ConfirmEditMasivo()" icon="pi pi-check"></p-button>
                </th>
                } -->
                <ng-container *ngIf="!btnEditAdelante">
                    <ng-container *ngTemplateOutlet="headerEdicion"></ng-container>
                </ng-container>
                <ng-container *ngTemplateOutlet="addHeaderEnd"></ng-container>
            </tr>
        </ng-template>

        <ng-template pTemplate="groupheader" let-rowdata let-rowIndex="rowIndex" let-expanded="expanded"
            *ngIf="metadataTableTree.length != 0 && !load">
            <tr class="body-table" (contextmenu)="onRowRightClick($event, rowdata)" #rowcontext>
                <td>
                    <button type="button" pButton pRipple [pRowToggler]="rowdata"
                        class="p-button-text p-button-rounded p-button-plain mr-2"
                        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                </td>
                <td *ngFor="let item2 of metadataTable; let i = index" class="body">
                    <span class="font-bold ml-2">{{rowdata[item2.field]}}</span>
                    <p-button pRipple icon="pi pi-ellipsis-h"
                        [style]="{'display': 'flex','justify-content': 'center','align-items': 'center','gap': '10px'}"
                        (click)="item2.function(rowdata)" *ngIf="item2.showButtonAccion == true" [icon]="item2.icon"
                        [disabled]="item2.inputStatus === 'lock'">
                    </p-button>
                </td>
                <ng-container *ngTemplateOutlet="addBodyEnd; context: { row: rowdata }"></ng-container>
            </tr>

            <p-contextMenu #expmenu [model]="contextMenu" [global]="false" appendTo="body"
                [target]="rowcontext"></p-contextMenu>
        </ng-template>


        <!-- <p-menu #menu [model]="items" [popup]="true" appendTo="body"></p-menu> -->

        <ng-template pTemplate="rowexpansion" let-rowdata let-rowIndex="rowIndex" class="template-tree"
            *ngIf="metadataTableTree.length != 0">
            <tr class="header-table-tree">
                <th></th>
                <th *ngFor="let item of metadataTableTree" class="header-tree">
                    <div class="flex align-items-center items-header">
                        {{item.title}}
                    </div>
                </th>
            </tr>
            <tr class="body-table" *ngFor="let item of rowdata['listadoserviciosasociados']">
                <td class="body-tree-footer"></td>
                <td *ngFor="let item2 of metadataTableTree" class="body-tree">
                    {{item[item2.field]}}
                </td>
            </tr>
            <tr>
                <td class="body-tree-footer"></td>
                <td *ngFor="let item2 of metadataTableTree" class="body-tree-footer">
                    {{item2.type == 'numeric' ? getTotal(rowdata['listadoserviciosasociados'],item2.field):'' }}
                </td>
            </tr>

        </ng-template>


        <ng-template pTemplate="body" let-rowdata let-i="rowIndex" let-editing="editing" let-expanded="expanded">

            <tr class="body-table" [pSelectableRow]="rowdata" [pEditableRow]="rowdata" [ngStyle]="styleRow?.(rowdata)"
                *ngIf="!load && rowdata.ESTADO_OBJ !== 'D' && rowdata.ESTADO_OBJ !== 'A' && rowdata.ESTADO_OBJ !== 'E' && rowdata?.tariff_accion !== 'HIJO'"
                (click)="onSelectRow(rowdata)">
                <td *ngIf="metadataTableTree.length != 0 && !load">
                    <button type="button" pButton pRipple [pRowToggler]="rowdata"
                        class="p-button-text p-button-rounded p-button-plain"
                        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                </td>
                <ng-container *ngTemplateOutlet="addBodyStart; context: { row: rowdata }"></ng-container>
                <td *ngIf="rowDelete">
                    <div class="flex align-items-center justify-content-center gap-2">
                        <button type="button" (click)="onRowDeletePre(rowdata, i)" [disabled]="disableDeleteRow"
                            [ngStyle]="colorBtnDel ? { 'background-color': 'var(--color-btn-rojo)', 'border-color': 'var(--color-btn-rojo)', 'color': '#fff' } : {}"
                            [style]="{ 'display': 'flex',  'justify-content': 'center',   'align-items': 'center',   'gap': '8px',  'padding': '6px 10px',
                          'border-radius': '6px',  'font-size': '14px',  'cursor': 'pointer',  'transition': 'background-color 0.3s ease',  'border': '1px solid transparent'    }">
                            <i class="pi pi-trash"></i>
                        </button>
                    </div>
                </td>

                <td *ngIf="rowEdit && btnEditAdelante">
                    <ng-container *ngTemplateOutlet="botonesEdicion; 
                        context: { rowdata: rowdata, i: i, editing: editing, table: dt1 }">
                    </ng-container>
                </td>

                <td *ngIf="modeSelected" style="text-align:center;" (click)="$event.stopPropagation()">
                    <p-radioButton name="rowSelector" [value]="rowdata"
                        [ngModel]="selectedRowInput"
                        (ngModelChange)="selectedRowInputChange.emit($event)">
                    </p-radioButton>
                </td>

                @for (item2 of metadata; track item2.field) {
                @if (item2.verColumna?.(rowdata) !== false) {
                <td class="body" [style.max-width]="item2.maxWidth" pFrozenColumn [frozen]="item2.frozen"
                    [style]="item2.inputType === 'color' || item2.colorDate==='colorDate' ? 'background-color: ' + item2.function(rowdata):'background-color: transparent'"
                    [ngStyle]="cellStyleByField[item2.field]?.(rowdata)">
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <form [formGroup]="group">
                                <div
                                    style="display: flex; align-items: center; gap: 2px; width: 100%; justify-content: center; height: 100%;">
                                    <ng-container *ngIf="!isFieldBlocked(item2.field); else readOnlyCell">
                                        <input pInputText [(ngModel)]="rowdata[item2.field]"
                                            *ngIf="item2.inputType == 'text'" [type]="item2.inputType" required
                                            [ngClass]="{'p-invalid': validationErrors[item2.field]}"
                                            [formControlName]="item2.field" [style]="'width:' + item2.maxWidth"
                                            (ngModelChange)="handleInputChange(item2.field,$event,rowdata)"
                                            pSize="small" [ngClass]="{ width: item2.widthInput,'font-size': '12px'  }">

                                        <!-- <input pInputText [(ngModel)]="rowdata[item2.field]"
                                            *ngIf=" item2.inputType == 'viewobservaciones' " [type]="item2.inputType"
                                            required [formControlName]="item2.field" [style]="'width:' + item2.maxWidth"
                                            (ngModelChange)="handleInputChange(item2.field,$event,rowdata)"
                                            pSize="small"> -->
                                        <textarea pInputTextarea [(ngModel)]="rowdata[item2.field]"
                                            *ngIf="item2.inputType == 'viewobservaciones'" required
                                            [formControlName]="item2.field" [style]="'width:' + item2.maxWidth"
                                            (ngModelChange)="handleInputChange(item2.field, $event, rowdata)"
                                            pAutoResize rows="3" pSize="small">
                                        </textarea>


                                        <input pInputText [(ngModel)]="rowdata[item2.field]"
                                            *ngIf="item2.inputType == 'textdisabled'" [type]="item2.inputType" required
                                            [formControlName]="item2.field" [style]="'width:' + item2.maxWidth "
                                            [readonly]="true" pSize="small">

                                        <input pInputText [(ngModel)]="rowdata[item2.field]"
                                            *ngIf="item2.inputType == 'dateDisabled'" [type]="item2.inputType" required
                                            [formControlName]="item2.field" [style]="'width:' + item2.maxWidth "
                                            [readonly]="true" pSize="small">

                                        <input pInputText [(ngModel)]="rowdata[item2.field]"
                                            *ngIf="item2.inputType == 'textOnlyInput'" [type]="item2.inputType" required
                                            [formControlName]="item2.field" [style]="'width:' + item2.maxWidth "
                                            pSize="small">

                                        <input pInputText [(ngModel)]="rowdata[item2.field]"
                                            *ngIf="item2.inputType == 'textResumidoOutput'" [type]="item2.inputType"
                                            required [formControlName]="item2.field" [style]="'width:' + item2.maxWidth"
                                            pSize="small">

                                        <input pInputText *ngIf="item2.popup == 'verDetalle'"
                                            required[style]="'width:' + item2.maxWidth " [readonly]="true"
                                            pSize="small">

                                        <p-select [(ngModel)]="rowdata[item2.field]"
                                            *ngIf="item2.inputType == 'dropdown'" [options]="item2.dropdown"
                                            class="datos-body" appendTo="body" [style]="{'width':'auto'}"
                                            [panelStyle]="{'width':'auto'}">
                                            [formControlName]="item2.field" size="small">
                                            <!-- {{imprimirInput(rowdata[item2.field], item2.inputType,null)}} -->
                                        </p-select>

                                        <!-- <p-inputNumber [(ngModel)]="rowdata[item2.field]"
                                            *ngIf="item2.inputType === 'int'  && item2.operacion !== 'multiplicar' "
                                            mode="decimal" [useGrouping]="false"
                                            [disabled]="item2.inputStatus === 'lock'" [formControlName]="item2.field"
                                            [style]="{'width' : item2.maxWidth}" styleClass="w-full" class="w-full"
                                            (ngModelChange)="handleInputChange(item2.field,$event,rowdata)"
                                            inputStyleClass="w-full"
                                            [style.width]="item2.widthInput ? item2.widthInput : null" size="small">
                                        </p-inputNumber> -->

                                        <p-inputNumber [(ngModel)]="rowdata[item2.field]"
                                            *ngIf="(item2.inputType == 'int' || item2.inputType == 'valor_unm' || item2.inputType == 'unidad_valor') && (!item2.operacion || editing)"
                                            mode="decimal" [useGrouping]="false"
                                            [disabled]="item2.inputStatus === 'lock'" [formControlName]="item2.field"
                                            [style]="{'width' : item2.maxWidth}"
                                            [style.width]="item2.widthInput ? item2.widthInput : null"
                                            [inputStyle]="{ width: item2.widthInput,'font-size': '12px'  }"
                                            (ngModelChange)="handleInputChange(item2.field,$event,rowdata)"
                                            (ngModelChange)="item2.operacion == 'multiplicar' || item2.operacion == 'sumar' ? actualizarOperacion(rowdata, item2.relacionMultiplicacion , item2.field) : null">

                                        </p-inputNumber>

                                        <!-- <p-inputNumber [(ngModel)]="rowdata[item2.field]"
                                            *ngIf="item2.inputType == 'decimal' || item2.inputType == 'moneda_monto'" mode="decimal" [minFractionDigits]="2"
                                            [maxFractionDigits]="5" [disabled]="item2.inputStatus === 'lock'"
                                            [formControlName]="item2.field" [style]="{'width' : item2.maxWidth}"
                                            (onChange)="handleInputChange(item2.field,$event,rowdata)">
                                        </p-inputNumber>

                                        Input para valores de multiplicación
                                        <p-inputNumber [(ngModel)]="rowdata[item2.field]"
                                            *ngIf="item2.operacion === 'multiplicar' && item2.inputType == 'decimal' && item2.operacion2 !== 'multiplicar2' || item2.operacion === 'multiplicar' && item2.operacion === 'sumar' && item2.inputType == 'decimal' && editing && item2.operacion2 !== 'multiplicar2'"
                                            mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="4"
                                            [disabled]="item2.inputStatus === 'lock'" [formControlName]="item2.field"
                                            styleClass="w-full" class="w-full"
                                            (ngModelChange)="actualizarMultiplicacion(rowdata,item2.field); actualizarMultiplicacion2(rowdata,item2.field)"
                                            inputStyleClass="w-full"
                                            [style.width]="item2.widthInput ? item2.widthInput : null" size="small">
                                        </p-inputNumber> -->

                                        <div style="display: flex; flex-direction: column; width: fit-content;">
                                            <div
                                                style="display: flex; justify-content: center; align-items: center; gap: 5px;">
                                                <p-inputNumber [(ngModel)]="rowdata[item2.field]"
                                                    *ngIf="( (item2.inputType == 'decimal' && item2.operacion2 != 'multiplicar2')|| item2.inputType == 'moneda_monto') && (!item2.operacion || editing)"
                                                    mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5"
                                                    [disabled]="item2.inputStatus === 'lock'"
                                                    (onFocus)="campoActivo = item2.field" inputStyleClass="custom-input"
                                                    [inputStyle]="{ width: item2.widthInput,'font-size': '12px'  }"
                                                    [formControlName]="item2.field" [style]="{'width' : item2.maxWidth}"
                                                    [style.width]="item2.widthInput ? item2.widthInput : null"
                                                    (ngModelChange)="handleInputChange(item2.field, $event, rowdata)"
                                                    (ngModelChange)="item2.operacion == 'multiplicar' || item2.operacion == 'sumar' ? actualizarOperacion(rowdata, item2.relacionMultiplicacion, item2.field) : null;
                                                item2.validar !== null? validarCampo(rowdata, item2) : null">
                                                </p-inputNumber>
                                                <p-button class="add-button" [icon]="item2.icon"
                                                    [pTooltip]="item2.toolTip"
                                                    *ngIf="erroresValidacion[rowdata.key + '_' + item2.field] && item2.inputType == 'decimal' && verbtn"
                                                    (onClick)="item2.function({event:$event,row:rowdata})" />
                                            </div>

                                            <div *ngIf="erroresValidacion[rowdata.key + '_' + item2.field] && item2.inputType == 'decimal'"
                                                class="error-message"
                                                style="display: flex; flex-wrap: wrap; max-width: auto; white-space: normal;">
                                                {{ erroresValidacion[rowdata.key + '_' + item2.field] }}
                                            </div>
                                        </div>

                                        <!-- Campo para mostrar el resultado de la multiplicación -->
                                        <p-inputNumber [(ngModel)]="rowdata[item2.field]"
                                            *ngIf="item2.inputType === 'decimalResultado'" mode="decimal"
                                            [minFractionDigits]="2" [maxFractionDigits]="4" [readonly]="true"
                                            [disabled]="true" [formControlName]="item2.field" styleClass="w-full"
                                            inputStyleClass="w-full" size="small" class="custom-select">
                                        </p-inputNumber>


                                        <!-- ACA SE DEBE MEJORAR LA LOGICA -->
                                        @if((item2.operacion2 === 'multiplicar2' || item2.operacion2 === 'sumar2') &&
                                        editing ){
                                        @if( item2?.disabledD?.(rowdata) !== true ){
                                        <div style="display: flex; flex-direction: column; width: fit-content;">
                                            <div
                                                style="display: flex; justify-content: center; align-items: center; gap: 5px;">
                                                <p-inputNumber [(ngModel)]="rowdata[item2.field]" mode="decimal"
                                                    [minFractionDigits]="2" [maxFractionDigits]="4"
                                                    [disabled]="item2.inputStatus === 'lock'"
                                                    [formControlName]="item2.field"
                                                    (ngModelChange)="item2.operacion2 ? actualizarOperacion(rowdata,item2.relacionMultiplicacion, item2.field): null; item2.validar !== null && puedeValidar[rowdata['key']] ? validarCampo(rowdata, item2) : null"
                                                    styleClass="w-full" class="w-full" inputStyleClass="w-full"
                                                    [style.width]="item2.widthInput ? item2.widthInput : null"
                                                    size="small" class="custom-select">
                                                </p-inputNumber>
                                                <p-button class="add-button" [icon]="item2.icon"
                                                    [pTooltip]="item2.toolTip"
                                                    *ngIf="erroresValidacion[rowdata.key + '_' + item2.field] && item2.operacion2 === 'multiplicar2' && verbtn"
                                                    (onClick)="item2.function({event:$event,row:rowdata})" />
                                            </div>
                                            <div *ngIf="erroresValidacion[rowdata.key + '_' + item2.field] && item2.operacion2 === 'multiplicar2'"
                                                class="error-message"
                                                style="display: flex; flex-wrap: wrap; max-width: auto; white-space: normal;">
                                                {{ erroresValidacion[rowdata.key + '_' + item2.field] }}
                                            </div>
                                        </div>
                                        }@else{
                                        <ng-container *ngTemplateOutlet="readOnlyCell"></ng-container>
                                        }
                                        }

                                        <p-inputNumber [(ngModel)]="rowdata[item2.field]"
                                            *ngIf="item2.inputType === 'decimalResultado2'" mode="decimal"
                                            [minFractionDigits]="2" [maxFractionDigits]="4"
                                            [disabled]="item2.inputStatus === 'lock'" [formControlName]="item2.field"
                                            styleClass="w-full" inputStyleClass="w-full" size="small"
                                            class="custom-select">
                                        </p-inputNumber>

                                        <div class="datos-body" *ngIf="item2.inputType === 'checkbox'">
                                            <p-checkbox [(ngModel)]="rowdata[item2.field]" [binary]="true"
                                                inputId="binary" [disabled]="item2?.disabledD?.(rowdata) ?? true"
                                                (onChange)="item2.function({event:$event,row:rowdata})"
                                                inputId="checkbox" [formControlName]="item2.field">
                                            </p-checkbox>
                                        </div>

                                        <div class="datos-body">
                                            <!-- {{rowdata[item2.field]}} -->
                                            <p-checkbox [readonly]="item2.readonly" [(ngModel)]="rowdata[item2.field]"
                                                [binary]="true" inputId="checkboxEditInput"
                                                [formControlName]="item2.field"
                                                *ngIf="item2.inputType == 'checkboxEditInput'" size="small">
                                            </p-checkbox>
                                        </div>

                                        <div class="datos-body">
                                            <p-radioButton *ngIf="item2.inputType === 'radioButton'"
                                                [(ngModel)]="rowdata[item2.field]"
                                                [inputId]="'radio-' + i + '-' + item2.field"
                                                [value]="rowdata[item2.field]" [formControlName]="item2.field"
                                                [name]="item2.field">
                                            </p-radioButton>
                                        </div>

                                        <div *ngIf="item2.inputType === 'buttonOneUse'">
                                            <!--Es un Boton que si recibe true de deshabilita// pTooltip={{item2.toolTip}}-->
                                            <p-button icon="pi pi-check" [disabled]="bool(rowdata[ item2.field])"
                                                (onClick)="item2.function({event:$event,row:rowdata})"
                                                [styleClass]="rowdata[item2.field] ? 'p-button-success' : ''">
                                            </p-button>
                                        </div>

                                        <p-datepicker [(ngModel)]="rowdata[item2.field]"
                                            *ngIf="item2.inputType == 'date'" appendTo="body"
                                            [formControlName]="item2.field" [dateFormat]="'dd/mm/yy'" size="small">
                                        </p-datepicker>

                                        <p-datepicker [(ngModel)]="rowdata[item2.field]"
                                            *ngIf="item2.inputType == 'datetimeseconds'" appendTo="body"
                                            [formControlName]="item2.field" size="small">
                                        </p-datepicker>

                                        @if(item2.inputType === 'autocomplete'){
                                        @if( item2?.disabledD?.(rowdata) !== true ){
                                        <p-select [(ngModel)]="rowdata[item2.field]" [options]="item2.dropdown"
                                            appendTo="body" placeholder="Seleccione" [filter]="true"
                                            [styleClass]="'custom-select ' + (validationErrors[item2.field] ? ' p-invalid' : '')"
                                            [showClear]="item2.showClear !== false"
                                            (onChange)="handleDropdownChange(item2.field,item2.children,$event,item2.dropdown,rowdata)"
                                            [formControlName]="item2.field" optionLabel="label"
                                            [virtualScroll]="item2.virtualScroll"
                                            [readonly]="item2.inputStatus === 'lock'"
                                            [style.width]="item2.widthInput ? item2.widthInput : 'auto'"
                                            [virtualScrollItemSize]="38" [scrollHeight]="'120px'"
                                            [panelStyle]="{'width':'max-content', 'min-width':'100%','max-height':'200px'}">
                                            <!-- {{imprimirInput(rowdata[item2.field], item2.inputType,null)}} -->
                                        </p-select>
                                        }
                                        @else{
                                        <ng-container *ngTemplateOutlet="readOnlyCell"></ng-container>
                                        }
                                        }

                                        <div class="w-full" *ngIf="item2.inputType === 'selectEdit'">
                                            <p-select [(ngModel)]="rowdata[item2.field]" [options]="item2.dropdown"
                                                appendTo="body" placeholder="Seleccionar" [filter]="true"
                                                [showClear]="true" optionLabel="label" optionValue="value"
                                                [formControlName]="item2.field"
                                                [disabled]="getDisabledSelectEdit(rowdata?.[item2.condicion],rowdata?.[item2.descCondicion])"
                                                (onChange)="handleDropdownChange2(item2.field,item2.children,$event,item2.dropdown,rowdata)"
                                                [virtualScroll]="item2.virtualScroll" class="custom-select"
                                                [readonly]="item2.inputStatus === 'lock'" styleClass="w-full">
                                            </p-select>
                                        </div>

                                        <p-button
                                            [style]="{'display': 'flex', 'justify-content': 'center', 'align-items': 'center'}"
                                            icon="pi pi-search"
                                            (onClick)="item2.function && item2.function({ event: $event, row: rowdata, modo: 'input', index:i })"
                                            *ngIf="item2.popup == 'y'" size="small">
                                        </p-button>

                                        <p-button
                                            [style]="{'display': 'flex', 'justify-content': 'center', 'align-items': 'center'}"
                                            [icon]="item2.icon"
                                            (onClick)="item2.function({event:$event,row:rowdata,modo:'input', index:i })"
                                            [loading]="item2.loading"
                                            *ngIf="item2.inputType === 'buttonPersonalizado' && item2.inputStatus == 'nolock'"
                                            size="small">
                                        </p-button>

                                        <!-- <p-button
                                        style="display: flex; justify-content: center;align-items: center;gap: 10px;"
                                        icon="pi pi-ellipsis-h" (click)="mostrarDetalleTexto(rowdata, item2.field)"
                                        *ngIf="item2.popup == 'verDetalle'">
                                    </p-button> -->
                                    </ng-container>
                                </div>
                                <ng-template #readOnlyCell
                                    style="display: flex; justify-content: center;align-items: center;">
                                    <span>{{ rowdata[item2.field]?.label ? rowdata[item2.field].label :
                                        (rowdata[item2.field] ?
                                        rowdata[item2.field] : '') }}</span>
                                </ng-template>

                                <!-- SE AGREGO ESTO -->
                                <div class="datos-body" *ngIf="item2.inputType == 'checkboxEdit'">
                                    <p-confirmPopup></p-confirmPopup>
                                    <p-checkbox [(ngModel)]="rowdata[item2.field]" [binary]="true" inputId="binary"
                                        [disabled]="resolveLockStatus(item2, rowdata)"
                                        (onChange)="item2.function?.({event:$event,row:rowdata})"
                                        inputId="checkboxEditInput" [formControlName]="item2.field">
                                    </p-checkbox>
                                </div>

                            </form>

                        </ng-template>

                        <ng-template pTemplate="output">
                            <!--====================Campos para OUTPUT====================-->
                            <!--==========Solo Vista==============-->
                            <span class="datos-body"
                                *ngIf="item2.inputType == 'text' || item2.inputType == 'autocomplete_1' || item2.inputType == 'textdisabled' || item2.inputType == 'color' || (item2.inputType === 'inputEdit' && rowdata[item2.modoOutput] === false) || (item2.inputType === 'inputNumberEdit' && rowdata[item2.modoOutput] === false)"
                                [ngStyle]="generateStyle(item2.style)">
                                {{ getSymbol(item2.simbolo, item2) }}
                                {{rowdata[item2.field]}}
                                {{imprimir(rowdata, item2.inputType,null)}}
                            </span>

                            <span class="datos-body" *ngIf="item2.inputType == 'textResumidoOutput'"
                                [ngStyle]="generateStyle(item2.style)">
                                {{ getSymbol(item2.simbolo, item2) }}
                                {{ rowdata[item2.field]?.length > 100 ? (rowdata[item2.field] | slice:0:100) + '...' :
                                rowdata[item2.field] }}
                            </span>

                            <span class="datos-body"
                                *ngIf="item2.inputType == 'dropdown' || (item2.inputType == 'autocomplete' && (rowdata[item2.modoOutput] ?? false) === false) || (item2.inputType === 'selectEdit' && rowdata[item2.modoOutput] === false)"
                                [ngStyle]="generateStyle(item2.style)">

                                {{ rowdata[item2.field]?.label ? rowdata[item2.field].label : (rowdata[item2.field] ?
                                rowdata[item2.field] : '') }}
                                {{imprimir(rowdata[item2.field], item2.inputType, item2.field)}}
                            </span>
                            <!--Para numeros decimales-->
                            <span class="datos-body"
                                *ngIf="item2.inputType == 'decimal' && item2.operacion == 'multiplicar' || item2.inputType == 'decimalResultado' || item2.inputType == 'decimal' && item2.operacion == 'sumar' || item2.inputType == 'decimal' || item2.inputType == 'moneda_monto' || item2.inputType == 'decimalResultado2'">
                                {{ getSymbol(item2.simbolo?? (item2.getSimboloMnd ? item2.getSimboloMnd(rowdata) :
                                null), item2) }}
                                {{ rowdata['motivo'] ? (rowdata['motivo'] === 'TEUS' || rowdata['motivo'] === 'Budget'
                                ||
                                rowdata['motivo'].includes('Teus') ?
                                formatNumber(rowdata[item2.field], 'int') : rowdata['motivo'] === '% Gasto' ?
                                formatNumber((rowdata[item2.field] * 100).toFixed(0), 'int') :
                                convertToDecimal(rowdata[item2.field])):convertToDecimal(rowdata[item2.field])
                                }}
                            </span>
                            <span class="datos-body"
                                *ngIf="item2.inputType == 'int' && item2.operacion == 'multiplicar' || item2.inputType == 'int' || item2.inputType == 'valor_unm' || item2.inputType == 'unidad_valor'"
                                [ngStyle]="generateStyle(item2.style)">
                                {{ getSymbol(item2.simbolo, item2) }}
                                {{ formatNumber(rowdata[item2.field], 'int')}}
                            </span>

                            <span class="datos-body" *ngIf="item2.inputType == 'percentage'">
                                {{ getFormattedPercentage(rowdata[item2.field]) }} %
                            </span>
                            <span class="datos-body" *ngIf="item2.inputType == 'porcentaje'"
                                [ngStyle]="generateStyle(item2.style)">
                                {{ formatPorcentaje(rowdata[item2.field], item2.decimales ?? 2) }}
                            </span>
                            <!-- <span *ngIf="item2.inputType === 'buttonOneUse'">
                                <p-button icon="pi pi-check" [disabled]="bool(rowdata[ item2.field])"
                                    (onClick)="item2.function({event:$event,row:rowdata})"
                                    [styleClass]="rowdata[item2.field] ? 'p-button-success' : ''">
                                </p-button>
                            </span> -->
                            <div class="datos-body" *ngIf="item2.inputType == 'buttonOneUse'">
                                <p-confirmPopup></p-confirmPopup>
                                <p-checkbox [(ngModel)]="rowdata[item2.field]" [binary]="true" inputId="binary"
                                    [disabled]="bool(rowdata[ item2.field])"
                                    (onChange)="item2.function({event:$event,row:rowdata})"
                                    [styleClass]="rowdata[item2.field] ? 'p-button-success' : ''">
                                </p-checkbox>
                            </div>

                            <div class="datos-body" *ngIf="item2.inputType === 'checkbox'">
                                <p-checkbox [(ngModel)]="rowdata[item2.field]" [binary]="true" inputId="binary"
                                    [disabled]="item2?.disabledD?.(rowdata) ?? true"
                                    (onChange)="item2.function({event:$event,row:rowdata})">
                                </p-checkbox>
                            </div>

                            <div class="datos-body">
                                <p-radioButton *ngIf="item2.inputType === 'radioButton'"
                                    [(ngModel)]="rowdata[item2.field]" [inputId]="'radio-' + i + '-' + item2.field"
                                    [value]="rowdata[item2.field]" [formControlName]="item2.field" [name]="item2.field"
                                    [disabled]="true">
                                </p-radioButton>
                            </div>

                            <span class="datos-body" *ngIf="item2.inputType == 'date'">
                                {{ rowdata[item2.field] ? util.formatearfecha(rowdata[item2.field], 'dd/mm/yyyy') : null
                                }}
                            </span>

                            <span class="datos-body" *ngIf="item2.inputType == 'datetime'">
                                {{rowdata[item2.field] ? util.formatearfecha(rowdata[item2.field],'dd/mm/yyyy hh:mm') :
                                null}}
                            </span>
                            <span class="datos-body" *ngIf="item2.inputType == 'datetimeseconds'">
                                {{rowdata[item2.field] ? util.formatearfecha(rowdata[item2.field],'yyyy-mm-dd hh:mm:ss')
                                : null}}
                            </span>

                            <span class="datos-body" *ngIf="item2.inputType == 'dateDisabled'"
                                [ngStyle]="generateStyle(item2.style)">
                                {{ rowdata[item2.field] ? util.formatearfecha(rowdata[item2.field], 'dd/mm/yyyy') :
                                null}}
                            </span>
                            <!--==========Campos Interactivos==========-->



                            <span *ngIf="item2.inputType == 'button'" class="datos-body">
                                <p-button icon="pi pi-eye" (onClick)="item2.function({event:$event,row:rowdata})">
                                </p-button>
                            </span>

                            <span *ngIf="item2.inputType === 'buttonPersonalizado'" class="row-button-table">
                                <p-button [icon]="item2.icon"
                                    *ngIf="!item2.condicion || rowdata[item2.condicion] === true" appendTo="body"
                                    (onClick)="item2.function({event:$event,row:rowdata,modo:'output', index:i })"
                                    [loading]="item2.loading" [pTooltip]="item2.toolTip"
                                    [disabled]="bool((item2.field != '' && rowdata[item2.field] !== undefined) ? !rowdata[item2.field] : (item2.disabled ?? (btnDisabled !== undefined ? btnDisabled : false)))">
                                    {{imprimirInput(rowdata[item2.field], item2.inputType,item2.field,
                                    item2.disabled,item2.toolTip )}}
                                </p-button>
                            </span>

                            <div class="row-button-table" *ngIf="item2.inputType == 'icon'">
                                <img [src]="item2.function(rowdata)" alt="" style="height: 16px;">
                            </div>


                            <div class="row-button-table" *ngIf="item2.inputType == 'icono'">
                                <i [class]="item2.iconI?.(rowdata)" [pTooltip]="item2.pTooltip?.(rowdata)"
                                    [tooltipPosition]="item2.toolTipPosition"
                                    [style]="{'color': item2.colorIcon?.(rowdata) + ' !important'}"></i>
                            </div>

                            <div class="row-button-table flex align-items-center justify-content-center h-10"
                                *ngIf="item2.inputType == 'icon#'">
                                <div class="leyenda-icon-container">
                                    <div class="leyenda-icon-table" [style.background]="item2.function(rowdata)"></div>
                                </div>
                            </div>

                            <!-- RadioButton para seleccionar una fila -->
                            <div class="datos-body">
                                <p-radioButton *ngIf="item2.inputType === 'radioButtonSelected'" name="rowSelector"
                                    [value]="rowdata" [ngModel]="selectedRowInput"
                                    (ngModelChange)="selectedRowInputChange.emit($event)">
                                </p-radioButton>
                            </div>

                            <div class="row-button-table"
                                *ngIf="item2.inputType == 'dialog' && rowdata[item2.field] != null">
                                <p>{{rowdata[item2.field]}}</p>
                                <p-button pRipple icon="pi pi-eye"
                                    (click)="showDialog(rowdata,item2.title,item2.field,'dialog',null,rowdata[item2.field])"
                                    class="p-button-rounded p-button-text p-button-danger" pTooltip="Ver Detalle"
                                    [tooltipPosition]="'left'"></p-button>
                            </div>


                            <div style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 5px"
                                *ngIf="item2.inputType == 'viewobservaciones'">
                                <p style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 200px">
                                    {{rowdata[item2.field]}}</p>
                                <!-- <p>

                                    prueba
                                 </p> -->
                                <p-button pRipple icon="pi pi-eye" (click)="showMessage(rowdata[item2.field],'80vw')"
                                    class="p-button-rounded p-button-text p-button-danger" pTooltip="Ver Detalle"
                                    [tooltipPosition]="'left'"></p-button>
                            </div>


                            <div class="row-button-table" *ngIf="item2.inputType == 'texticon'"
                                style="display: flex; justify-content: center;align-items: center;gap: 10px;">
                                <div style="width: 20px;text-align: right">{{rowdata[item2.field]}}</div>
                                <img [src]="item2.function(rowdata)" alt="" style="height: 15px;">
                            </div>

                            <div class="row-button-table" *ngIf="item2.inputType == 'textcolor'"
                                style="display: flex; justify-content: center;align-items: center;gap: 10px;">
                                <div [style]="'color: ' + item2.function(rowdata) "> {{ rowdata['motivo'] ?
                                    (rowdata['motivo'] === 'TEUS' || rowdata['motivo'] === 'Budget'
                                    ||
                                    rowdata['motivo'].includes('Teus') ?
                                    formatNumber(rowdata[item2.field], 'int') : rowdata['motivo'] === '% Gasto' ?
                                    formatNumber((rowdata[item2.field] * 100).toFixed(0), 'int') :
                                    convertToDecimal(rowdata[item2.field])):convertToDecimal(rowdata[item2.field])
                                    }}</div>
                            </div>

                            <div class="w-auto" *ngIf="item2.inputType == 'dateEdit'">
                                <p-datepicker [(ngModel)]="rowdata[item2.field]" appendTo="body" [readonlyInput]="false"
                                    (onSelect)="handleDateSelect($event)" dateFormat="dd/mm/yy" styleClass="w-auto"
                                    [showTime]="false">
                                </p-datepicker>
                                <p-button [disabled]="!selectedDate" icon="pi pi-save" *ngIf="item2.visible"
                                    (onClick)=" item2.function({event:$event,row:rowdata});isDisabled()">
                                </p-button>
                            </div>

                            <div class="row-button-table" *ngIf="item2.inputType == 'textAreaEdit'">
                                <p-button *ngIf="rowdata[item2.field] == null || rowdata[item2.field] ==''"
                                    icon="pi pi-eye"
                                    (click)="showDialog(rowdata,item2.title,item2.field,'textAreaEdit',item2.function,rowdata[item2.field])"
                                    class="p-button-rounded p-button-text p-button-danger" pTooltip="Ver Detalle"
                                    styleClass=" p-button-secondary" [tooltipPosition]="'left'"></p-button>

                                <p-button *ngIf="rowdata[item2.field] != null && rowdata[item2.field] !=''" pRipple
                                    icon="pi pi-eye"
                                    (click)="showDialog(rowdata,item2.title,item2.field,'textAreaEdit',item2.function,rowdata[item2.field])"
                                    class="p-button-rounded p-button-text p-button-danger" pTooltip="Ver Detalle"
                                    [tooltipPosition]="'left'"></p-button>
                            </div>

                            <div class="datos-body" *ngIf="item2.inputType == 'checkboxEdit'">
                                <!-- <p-confirmPopup></p-confirmPopup> -->
                                <p-checkbox [(ngModel)]="rowdata[item2.field]" [binary]="true" inputId="binary"
                                    [disabled]="resolveLockStatus(item2, rowdata)"
                                    (onChange)="item2.function?.({event:$event,row:rowdata})">
                                </p-checkbox>
                            </div>

                            <div class="datos-body" *ngIf="item2.inputType == 'checkboxEditInput'">
                                <p-confirmPopup></p-confirmPopup>
                                <!-- {{rowdata[item2.field]}} -->
                                <p-checkbox [(ngModel)]="rowdata[item2.field]" [binary]="true"
                                    inputId="checkboxEditInput" readonly="true">
                                    <!-- [disabled]="true" -->
                                </p-checkbox>

                            </div>

                            <div class="datos-body" *ngIf="item2.inputType == 'checkboxEditOpcionUnica'">
                                <p-confirmPopup></p-confirmPopup>
                                <p-checkbox [(ngModel)]="rowdata[item2.field]" [binary]="true" inputId="binary"
                                    [disabled]="item2?.disabledD?.(rowdata)"
                                    (onChange)="onCheckboxChange($event, item2.field, rowdata, i)">
                                </p-checkbox>
                            </div>

                            <!-- <div class="datos-body" *ngIf="item2.inputType === 'radioButtonEdit'">
                                                            <p-radioButton [(ngModel)]="rowdata[item2.field]" [inputId]="'radio-' + i + '-' + item2.field"
                                    [value]="rowdata[item2.field]" [formControlName]="item2.field" [name]="item2.field"
                                    (onChange)="onRadioButtonChange($event, rowdata)">
                                </p-radioButton>
                            </div> -->

                            <div class="row-button-table" *ngIf="item2.inputType == 'textArea'">

                                <p-button pRipple icon="pi pi-eye"
                                    (click)="showDialog(rowdata,item2.title,item2.field,'textArea',item2.function,rowdata[item2.field])"
                                    class="p-button-rounded p-button-text p-button-danger" pTooltip="Ver Detalle"
                                    [tooltipPosition]="'left'"></p-button>
                            </div>

                            <div class="row-button-table" *ngIf="item2.inputType == 'textAreaParametros'">

                                <p-button pRipple icon="pi pi-eye"
                                    (click)="showDialog(rowdata,item2.title,item2.field,'textAreaParametros',item2.function,rowdata[item2.field])"
                                    class="p-button-rounded p-button-text p-button-danger" pTooltip="Ver Detalle"
                                    [tooltipPosition]="'left'"></p-button>
                            </div>

                            <p-button
                                [style]="{'display': 'flex','justify-content': 'center','align-items': 'center','gap': '10px'}"
                                icon="pi pi-download" (click)="descargarArchivo(rowdata, i)"
                                *ngIf="item2.showDowndloadButton == true">
                            </p-button>

                            <p-button
                                [style]="{'display': 'flex','justify-content': 'center','align-items': 'center','gap': '10px'}"
                                icon="pi pi-eye" (click)="mostrarDetalleTexto(rowdata, item2.field)"
                                *ngIf="item2.popup == 'verDetalle'" pTooltip="Ver detalle de observaciones">
                            </p-button>

                            <div style="display: flex; justify-content: center;align-items: center; padding: 2px;">
                                <p-button pRipple icon="pi pi-ellipsis-h"
                                    [style]="{'display': 'flex','justify-content': 'center','align-items': 'center','gap': '10px'}"
                                    (click)="item2.function(rowdata)" *ngIf="item2.showButtonAccion == true"
                                    [tooltipPosition]="item2.toolTipPosition" [icon]="item2.icon"
                                    [disabled]="item2.inputStatus === 'lock'" [pTooltip]="item2.toolTip">
                                </p-button>
                            </div>

                            <div *ngIf="item2.inputType == 'checkList'" class="datos-body">
                                <p-checkbox [(ngModel)]="rowdata[item2.field]" [binary]="true" inputId="binary"
                                    [disabled]="rowdata[item2.validar] === true"
                                    (onChange)="onChangeCheckList($event,rowdata)">
                                </p-checkbox>
                            </div>

                            <div *ngIf="item2.inputType == 'checkList2'" class="datos-body">
                                <p-checkbox [(ngModel)]="rowdata[item2.field]" [binary]="true" inputId="binary"
                                    [disabled]="rowdata[item2.validar] === true" [pTooltip]="item2.pTooltip(rowdata)"
                                    (onChange)="onChangeCheckList2($event,rowdata,item2)">
                                </p-checkbox>
                            </div>

                            <div *ngIf="item2.inputType == 'dropdownButton'">
                                <p-select [options]="item2.dropdown" [(ngModel)]="rowdata[item2.field]" appendTo="body"
                                    showClear="true" name="valueDropdownButton"></p-select>
                                <p-button icon="pi pi-save" variant="outlined"
                                    (onClick)="item2.function({row: rowdata, value: rowdata[item2.field]})"></p-button>
                            </div>

                            <div *ngIf="item2.inputType == 'inputButton'">
                                <input pInputText type="text" [(ngModel)]="rowdata[item2.field]" pSize="small">
                                <p-button icon="pi pi-save" variant="outlined"
                                    (onClick)="item2.function({row: rowdata, value: rowdata[item2.field]})"></p-button>
                            </div>

                            <div class="w-full"
                                *ngIf="item2.inputType === 'inputEdit' && rowdata[item2.modoOutput] === true">
                                <input pInputText [(ngModel)]="rowdata[item2.field]" type="text"
                                    [disabled]="getDisabledSelectEdit(rowdata?.[item2.condicion],rowdata?.[item2.descCondicion])"
                                    [style]="'width:' + item2.maxWidth"
                                    (onChange)="handleInputChange(item2.field,$event,rowdata)" />
                            </div>

                            <!-- <div class="w-full"
                                *ngIf="item2.inputType === 'autocomplete' && (rowdata[item2.modoOutput] ?? false) === true">
                                <p-select [(ngModel)]="rowdata[item2.field]" [options]="item2.dropdown" appendTo="body"
                                    placeholder="Seleccionar" styleClass="w-full" [filter]="true" [showClear]="true"
                                    optionLabel="label" optionValue="value"
                                    [disabled]="getDisabledSelectEdit(rowdata?.[item2.condicion],rowdata?.[item2.descCondicion])"
                                    (onChange)="handleDropdownChange2(item2.field,item2.children,$event,item2.dropdown,rowdata)"
                                    [virtualScroll]="item2.virtualScroll" [readonly]="item2.inputStatus === 'lock'">
                                </p-select>
                            </div> -->

                            <div class="w-full"
                                *ngIf="item2.inputType === 'selectEdit' && rowdata[item2.modoOutput] === true">
                                <p-select [(ngModel)]="rowdata[item2.field]" [options]="item2.dropdown" appendTo="body"
                                    placeholder="Seleccionar" styleClass="w-full" [filter]="true" [showClear]="true"
                                    class="formatosselect" optionLabel="label" optionValue="value"
                                    [disabled]="getDisabledSelectEdit(rowdata?.[item2.condicion],rowdata?.[item2.descCondicion])"
                                    (onChange)="handleDropdownChange2(item2.field,item2.children,$event,item2.dropdown,rowdata)"
                                    [virtualScroll]="item2.virtualScroll" [readonly]="item2.inputStatus === 'lock'">
                                </p-select>
                            </div>

                            <p-select
                                *ngIf="item2.inputType === 'autocomplete' && (rowdata[item2.modoOutput] ?? false) === true"
                                [options]="item2.dropdown" optionLabel="label" optionValue="value"
                                [ngModel]="rowdata[item2.field]?.value ?? rowdata[item2.field]" appendTo="body"
                                class="formatosselect" [filter]="true" class="p-inputtext-sm"
                                [virtualScroll]="item2.virtualScroll" [readonly]="item2.inputStatus === 'lock'"
                                [placeholder]="item2.placeholder" [showClear]="item2.showClear" dataKey="value"
                                (onChange)="handleDropdownChange2(item2.field,item2.children,$event,item2.dropdown,rowdata)"
                                (onChange)="actualizarValue(rowdata, item2.field, $event.value, item2.dropdown)"
                                (onClick)="imprimirDepuracion(rowdata[item2.field], item2.inputType, item2.field, item2.dropdown)">
                            </p-select>

                            <div style="display: flex; flex-direction: column; width: fit-content;"
                                *ngIf="item2.inputType === 'inputNumberEdit' && rowdata[item2.modoOutput] === true">
                                <div style="display: flex; justify-content: center; align-items: center; gap: 5px;">
                                    <p-inputNumber [(ngModel)]="rowdata[item2.field]" [minFractionDigits]="2"
                                        [maxFractionDigits]="4"
                                        (onFocus)="item2.onFocusfunction({event:$event,row:rowdata})"
                                        [disabled]="getDisabledSelectEdit(rowdata?.[item2.condicion],rowdata?.[item2.descCondicion])"
                                        (onChange)="handleInputChange(item2.field,$event,rowdata)" styleClass="w-full"
                                        class="w-full" inputStyleClass="w-full"
                                        (onBlur)="item2.onBlurfunction({event:$event,row:rowdata})"
                                        [style.width]="item2.widthInput ? item2.widthInput : null" size="small"
                                        (ngModelChange)="item2.operacion2 ? actualizarMultiplicacion2(rowdata,item2.field): null; ; item2.validar !== null ? validarCampo(rowdata, item2) : null"
                                        (ngModelChange)="triggerActualizarEstado(rowdata,item2?.actualizarEstado)" />
                                    <p-button class="add-button" [icon]="item2.icon" [pTooltip]="item2.toolTip"
                                        *ngIf="erroresValidacion[rowdata.key + '_' + item2.field] && item2.inputType === 'inputNumberEdit' && verbtn"
                                        (onClick)="item2.function({event:$event,row:rowdata})" />
                                </div>
                                <div *ngIf="erroresValidacion[rowdata.key + '_' + item2.field] && item2.inputType === 'inputNumberEdit'"
                                    class="error-message"
                                    style="display: flex; flex-wrap: wrap; max-width: auto; white-space: normal;">
                                    {{ erroresValidacion[rowdata.key + '_' + item2.field] }}
                                </div>
                            </div>

                            <div *ngIf="item2.inputType === 'textoEditOutput'">
                                <textarea [(ngModel)]="rowdata[item2.field]" [style.width]="item2.maxWidth"
                                    [attr.maxlength]="item2.maxLength" rows="2" cols="15"
                                    [readonly]="item2.inputStatus === 'lock'" pTextarea pSize="small" required
                                    class="w-full"></textarea>
                            </div>

                <td class="datos-body" *ngIf="item2.inputType == 'dropdownOnlyOutput'">
                    <p-select [options]="item2.dropdown" optionLabel="label" optionValue="value" appendTo="body"
                        [filter]="true" class="p-inputtext-sm" [(ngModel)]="rowdata[item2.field]"
                        [virtualScroll]="item2.virtualScroll" [readonly]="item2.inputStatus === 'lock'"
                        [placeholder]="item2.placeholder" [showClear]="item2.showClear"
                        [panelStyle]="{'width':'450px', 'min-width':'100%','max-height':'400px'}">
                        (onClick)="imprimirDepuracion(rowdata[item2.field],item2.inputType,item2.field,item2.dropdown)">
                    </p-select>
                </td>

        </ng-template>
        </p-cellEditor>

        </td>
        }
        }

        <td *ngIf="rowEdit && !btnEditAdelante">
            <ng-container *ngTemplateOutlet="botonesEdicion; 
                context: { rowdata: rowdata, i: i, editing: editing, table: dt1 }">
            </ng-container>
        </td>

        <!-- <td *ngIf="rowEdit && (btnEditAdelante == false)">
            <div class="flex align-items-center justify-content-center gap-2"
                style="gap: 7px; display: flex; justify-content: center;">
                <div style="display: flex; align-items: center;"
                    [ngStyle]="{ 'pointer-events': editDisabled || disableEditRow || rowdata.disabled ? 'none' : 'auto' }">
                    <p-button *ngIf="!editing" pRipple pInitEditableRow icon="pi pi-pencil"
                        (onClick)="onRowEditInit(rowdata)" class="p-button-rounded p-button-text"
                        [disabled]="editDisabled || disableEditRow || rowdata.disabled"
                        [pTooltip]="rowdata?.toolTipEdit || ''"></p-button>
                </div>
                <div style="display: flex; align-items: center;"
                    [ngStyle]="{ 'pointer-events': acceptDisabled ? 'none' : 'auto' }">
                    <p-button *ngIf="editing" pSaveEditableRow icon="pi pi-check"
                        (onClick)="onRowEditSave(rowdata,i);  saveEdit.emit()" [size]="'small'"
                        class="p-button-rounded p-button-text p-button-success" [disabled]="acceptDisabled"></p-button>
                </div>
                <p-button *ngIf="editing" pCancelEditableRow icon="pi pi-times" [size]="'small'"
                    (onClick)="onRowEditCancel(rowdata, i)"
                    class="p-button-rounded p-button-text p-button-danger"></p-button>
            </div>
        </td> -->

        <ng-container *ngTemplateOutlet="addBodyEnd; context: { row: rowdata }"></ng-container>

        </tr>

        <tr *ngIf="load">
            @for (item2 of metadata; track item2.field) {
            @if (item2.verColumna?.(rowdata) !== false) {
            <td><p-skeleton></p-skeleton></td>
            }
            }
        </tr>
        </ng-template>

        //FOOTER -- SE AGREGARON TOTALES
        <ng-template pTemplate="footer">
            <tr *ngIf="totales">
                <td *ngIf="addBodyStart"></td>

                <td *ngIf="rowDelete"></td>
                @for (item2 of metadata; track item2.field) {
                @if (item2.verColumna?.(null) !== false) {
                <td class="body" style="text-align: center;" pFrozenColumn [frozen]="item2.frozen">
                    {{ item2.rowFooter
                    ? getRowFooter(dt1.filteredValue || data, item2.field, item2.rowFooter, item2.inputType) + (item2.inputType === 'porcentaje' ? '%' : '') + ' '
                    : ''
                    }}
                </td>
                }
                }
            </tr>

        </ng-template>

        <ng-template pTemplate="summary" *ngIf="exportData">
            <div style="display: flex;justify-content: right;" *ngIf="exportData">
                <p-button icon="pi pi-file-excel" styleClass="p-button-sm p-button-success p-button-outlined"
                    (onClick)="export()"></p-button>
            </div>
        </ng-template>

        <ng-template #headerEdicion>
            <th *ngIf="rowEdit && !addRow"
                style="display: flex; justify-content: center; align-items: center; height: 33px;">
            </th>
            <th *ngIf="addRow" style="display: flex; justify-content: center; align-items: center;">
                <p-button (click)="ConfirmEditMasivo()" icon="pi pi-check"></p-button>
            </th>
        </ng-template>

        <ng-template #botonesEdicion let-rowdata="rowdata" let-i="i" let-editing="editing" let-table="table">
            <div class="flex align-items-center justify-content-center gap-2">

                <div *ngIf="!editing">
                    <p-button icon="pi pi-pencil" class="p-button-rounded p-button-text"
                        (onClick)="table.initRowEdit(rowdata); onRowEditInit(rowdata)"
                        [disabled]="editDisabled || disableEditRow || rowdata.disabled">
                    </p-button>
                </div>

                <div *ngIf="editing">
                    <p-button icon="pi pi-check" [size]="'small'"
                        class="p-button-rounded p-button-text p-button-success"
                        (onClick)="onRowEditSave(rowdata, i); table.onEditComplete.emit({ data: rowdata, index: i }); saveEdit.emit()">
                    </p-button>
                </div>

                <div *ngIf="editing">
                    <p-button icon="pi pi-times" [size]="'small'" class="p-button-rounded p-button-text p-button-danger"
                        (onClick)="table.cancelRowEdit(rowdata, i); onRowEditCancel(rowdata, i)">
                    </p-button>
                </div>

            </div>
        </ng-template>

        <!-- <ng-template #botonesEdicion let-rowdata="rowdata" let-i="i" let-editing="editing" let-table="table">

            <div class="flex align-items-center justify-content-center gap-2">

                <div *ngIf="!editing">
                    <p-button icon="pi pi-pencil" class="p-button-rounded p-button-text"
                        (onClick)="table.initRowEdit(rowdata); onRowEditInit(rowdata)"
                        [disabled]="editDisabled || disableEditRow || rowdata.disabled">
                    </p-button>
                </div>

                <div *ngIf="editing">
                    <p-button icon="pi pi-check" [size]="'small'"
                        class="p-button-rounded p-button-text p-button-success"
                        (onClick)="table.saveRowEdit(rowdata, i); onRowEditSave(rowdata, i); saveEdit.emit()">
                    </p-button>
                </div>

                <p-button *ngIf="editing" icon="pi pi-times" [size]="'small'"
                    class="p-button-rounded p-button-text p-button-danger"
                    (onClick)="table.cancelRowEdit(rowdata, i); onRowEditCancel(rowdata, i)">
                </p-button>

            </div>

        </ng-template> -->
    </p-table>

    <p-dialog header="GENERAL" [(visible)]="visibleP_Dialog_General"><!--[style]="{ width: '50vw' }"-->
        <ng-template pTemplate="header">
            <span class="text-base font-bold title-dialog">{{tituloP1_Dialog}}</span>
        </ng-template>
        <!--De anthony-->
        <ng-container *ngIf="visibleDialog">
            <div class="title-dialog">{{mensajeDialog.title}}</div>
            <div class="dialog-mesaje text-xs">
                {{mensajeDialog.message}}
            </div>
        </ng-container>
        <!--Para TextArea-->
        <div *ngIf="visibleTextArea" class="flex py-2 justify-content-center"
            style="display: flex; justify-content: center;align-items: center; flex-direction: column-reverse; gap:10px">
            <div class="card flex justify-content-center">
                <textarea rows="5" cols="30" pTextarea [(ngModel)]="datoTextArea" style="resize: none;"></textarea>
            </div>
        </div>
        <!--Para TextAreaParametros-->
        <div *ngIf="visibleTextAreaParametros" class="flex py-2 justify-content-center"
            style="display: flex; justify-content: center;align-items: center; flex-direction: column-reverse; gap:10px">
            <div class="card flex justify-content-center">
                <textarea rows="12" cols="150" pTextarea [(ngModel)]="datoTextArea" style="resize: none;"></textarea>
            </div>
        </div>
        <!--Para TextAreaEdit-->
        <div *ngIf="visibleTextAreaEdit" class="flex py-2 justify-content-center"
            style="display: flex; justify-content: center;align-items: center; flex-direction: column-reverse; gap:10px">
            <div class="card flex justify-content-center">
                <textarea rows="5" cols="30" pTextarea [(ngModel)]="datoTextArea" style="resize: none;"></textarea>
            </div>
            <p-button icon="pi pi-check" (click)="onConfirm()"></p-button>
        </div>
    </p-dialog>


    <!-- <p-dialog header="TEXTAREA" [(visible)]="visibleTextArea" [style]="{width: '60vw'}" appendTo="body">

        textarea
    </p-dialog> -->


</div>

<p-dialog header="Opciones" [(visible)]="optionColumns" [style]="{width: '50vw'}">
    <p-pickList [source]="mainmetadata" [target]="metadata" sourceHeader="DISPONIBLES" targetHeader="SELECCIONADOS"
        [dragdrop]="true" [responsive]="true" [sourceStyle]="{ height: '20rem' }" [targetStyle]="{ height: '20rem' }"
        filterBy="title" sourceFilterPlaceholder="" targetFilterPlaceholder="" breakpoint="1400px">
        <ng-template let-product pTemplate="item">
            <div class="flex flex-wrap p-2 align-items-center gap-3">
                <div class="flex-1 flex flex-column gap-2">
                    <span style="font-size: 11px;font-weight: 500;text-transform: uppercase;">{{ product.title }}</span>
                </div>
            </div>
        </ng-template>
    </p-pickList>
    <p-button icon="pi pi-save" (onClick)="saveOptionColumns()" pTooltip="guardar"></p-button>
</p-dialog>

<!-- ----------------------------------------------------------------------------------------------------------------------------------------------------------- -->
<!-- ------------------------------------------------------------ MESSAGE DIALOG ------------------------------------------------------------------------------- -->
<!-- ----------------------------------------------------------------------------------------------------------------------------------------------------------- -->

<!-- <p-dialog header="Observaciones" [(visible)]="dialogMessage" [style]="{width: dialogConfig.size}"> -->
<!-- <div class="card flex justify-content-center">
        <textarea rows="5" cols="30" pTextarea [(ngModel)]="dialogConfig.message" style="resize: none;"></textarea>
    </div> -->
<!-- <div class="dialog-mesaje text-xs">
        {{dialogConfig.message}} -->
<!-- <p-editor formControlName="correo" [style]="{'height': 'auto'}" #editorRef></p-editor> -->
<!-- </div> -->
<!-- <p-editor [style]="{'height': 'auto'}" #editorRef (ngModel)="dialogConfig.message"></p-editor> -->
<!-- <p-button icon="pi pi-save" (onClick)="saveOptionColumns()" pTooltip="guardar"></p-button> -->
<!-- </p-dialog> -->

<!-- <p-dialog header="Observaciones"
          [(visible)]="dialogMessage"
          [style]="{ width: dialogConfig.size }"
          [modal]="true">
  <div [innerHTML]="dialogConfig.message"
       style="max-height: 300px; overflow-y: auto; padding: 1rem;">
  </div>
</p-dialog> -->

<p-dialog header="Observaciones" [(visible)]="dialogMessage" [style]="{ width: '50vw' }" [modal]="true"
    [closable]="true" [baseZIndex]="99999999999999999999" appendTo="body">
    <div [innerHTML]="dialogConfig.message" style="max-height: 400px;
              overflow-y: auto;
              padding: 1rem;
              font-size: 14px;
              line-height: 1.6;
              white-space: pre-wrap;">
    </div>
</p-dialog>





<style>
    :host ::ng-deep .p-datepicker {
        width: 110px;
    }

    :host ::ng-deep .p-datepicker .p-inputtext {
        padding: 4px;
    }

    /* :host ::ng-deep .p-inputtext{
        width: 35vw;
    } */

    :host ::ng-deep .p-button {
        padding: 0.6rem;
        width: 10px;
        height: 10px;
    }

    :host ::ng-deep .pi {
        font-size: 0.7rem;
    }

    :host ::ng-deep .p-button {
        padding: 0.6rem;
        width: 10px;
        height: 10px;
    }

    :host ::ng-deep .p-dialog .p-dialog-header .p-dialog-header-icon {
        width: 1rem;
        height: 1rem;
    }

    :host ::ng-deep.p-dialog .p-dialog-content {
        padding: 3px;
    }


    ::ng-deep .p-overlay.p-select-panel {
        width: 250px !important;
        min-width: max-content !important;
    }

    ::ng-deep .p-select-item {
        white-space: nowrap !important;
        overflow: visible !important;
    }
</style>